import { render, staticRenderFns } from "./AccountHolderDialog.vue?vue&type=template&id=78c2b8a2&scoped=true&"
import script from "./AccountHolderDialog.vue?vue&type=script&lang=js&"
export * from "./AccountHolderDialog.vue?vue&type=script&lang=js&"
import style0 from "./AccountHolderDialog.vue?vue&type=style&index=0&id=78c2b8a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c2b8a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VDialog})
